import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "./NoticeDetail.css";

class NoticeDetail extends Component {
  render() {
    const { classes, handleCancelDetail, detailData } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.title}>
          <div style={{ fontSize: 18, flexGrow: 1 }}>Details</div>
          <div className={classes.iconStyle}>
            <CancelIcon onClick={handleCancelDetail} />
          </div>
        </div>
        <div className={classes.body}>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Notice Title</div>
            <div>{detailData.title}</div>
          </ListItem>
          <div style={{ textAlign: "center" }}>Description</div>
          <div style={{ textAlign: "center" }}>{detailData.description}</div>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(NoticeDetail);
